import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../../../types/results';
import { getAllProducs } from '../../../../utils/trackings';

export function trackRemoveFolder(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'delete_collection',
    label: '',
    products,
  });
}
